var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon',{class:_vm.selectClass,attrs:{"name":_vm.selectIcon}})
}
var staticRenderFns = []

export { render, staticRenderFns }